import { makeStyles } from "@fluentui/react-components";

export const useYellowPadLogoStyles = makeStyles({
  logo: {
    flexShrink: 0,
  },
});
